import buildURL from 'axios/lib/helpers/buildURL';
import LRU from 'lru-cache';

import { logger } from '@/plugins/logger';

export default (adapter) => {
  try {
    const cacheLRU = new LRU({ ttl: 1000 * 30, max: 100 });

    return async (config) => {
      const {
        url, params, paramsSerializer, method, data = {}, cached = false,
      } = config;

      if ((method === 'get' || method === 'post') && cached) {
        const index = buildURL(url, { ...params, ...data }, paramsSerializer);
        const cachedPromise = cacheLRU.get(index);

        if (cachedPromise) {
          return cachedPromise;
        }

        const promise = adapter(config).catch((error) => {
          cacheLRU.delete(index);
          throw error;
        });
        cacheLRU.set(index, promise);
        return promise;
      }

      return adapter(config);
    };
  } catch (e) {
    logger.error(e);
  }
};
